import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { EmailData } from "src/app/shared/models/email-data";

@Injectable({
    providedIn: 'root',
  })
  export class EmailService {
    baseUrl: string = environment.cloudUrl;
    emailUrl: string = this.baseUrl + 'password/request/reset';
  
    constructor(private http: HttpClient) {}
    forgot(data: EmailData ): Observable<any> {
        const url = this.emailUrl;
        return this.http.post<EmailData>(url, data).pipe(
          map((data) => {
            return data;
          }),
          catchError(this.handleError)
        );       
      }
      handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // server-side error
          errorMessage = error.error;
        }
        return throwError(errorMessage);
      }
    }
    